import { LogIn } from 'lucide-react';
import { authClient } from '@/features/auth/lib/auth-client';
import { useSession } from '@/features/auth/hooks/use-session';
import { Button } from '@/shared/components/button';
import { useScheduledCards } from '../hooks/use-scheduled-cards';
import { useReviewMode } from '../hooks/use-review-mode';
import { cn } from '@/shared/lib/utils';

export function DueBadge() {
  const { isAuthenticated, isPending } = useSession();
  const { dueNow } = useScheduledCards(isAuthenticated);
  const { isReviewMode, toggleReviewMode } = useReviewMode();

  if (isPending) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full border border-transparent px-3.5 py-2 text-sm font-medium">
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-muted/50" />
        <span className="invisible">Review</span>
      </span>
    );
  }

  if (!isAuthenticated) {
    return (
      <Button
        variant="ghost"
        size="sm"
        className="h-11 rounded-full gap-1.5 text-sm font-medium text-gold hover:text-gold hover:bg-gold/10"
        onClick={() => authClient.signIn.social({ provider: 'google' })}
      >
        <LogIn className="h-4 w-4" />
        Sign in
      </Button>
    );
  }

  const dueCount = dueNow.length;

  const label = dueCount > 0 ? `Review (${dueCount})` : 'Review';

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isReviewMode}
      aria-label="Review mode"
      onClick={toggleReviewMode}
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3.5 py-2 text-sm font-medium transition-colors cursor-pointer',
        isReviewMode
          ? 'border-primary bg-primary text-primary-foreground'
          : 'border-border text-muted-foreground hover:border-foreground/20 hover:text-foreground',
      )}
    >
      <span
        className={cn(
          'h-1.5 w-1.5 shrink-0 rounded-full transition-colors',
          isReviewMode ? 'bg-primary-foreground' : 'bg-muted-foreground/40',
        )}
      />
      {label}
    </button>
  );
}
